import Vue from 'vue'
import VueResource from 'vue-resource'
import VueTheMask from 'vue-the-mask'
import VueCookies from 'vue-cookies'
import store from './vuex/store'
import config from './config'
import eventBus from 'shared/event-bus'
import App from './modules/App.vue'
import Icon from 'vue-awesome/components/Icon.vue'
import vSelect from 'vue-select'

// Validate
import 'shared/helpers/vee-validate'
import 'shared/helpers/validator'

// Icons
import 'vue-awesome/icons/calendar'
import 'vue-awesome/icons/repeat'
import 'vue-awesome/icons/question-circle'
import 'vue-awesome/icons/male'
import 'vue-awesome/icons/home'
import 'vue-awesome/icons/bar-chart'
import 'vue-awesome/icons/heartbeat'
import 'vue-awesome/icons/sort'
import 'vue-awesome/icons/play-circle'
import 'vue-awesome/icons/money'
import 'vue-awesome/icons/info-circle'
import 'vue-awesome/icons/clock-o'
import 'vue-awesome/icons/comments'
import 'vue-awesome/icons/calculator'
import 'vue-awesome/icons/exclamation-triangle'
import 'vue-awesome/icons/sign-in'
import 'vue-awesome/icons/list-alt'
import 'vue-awesome/icons/sort-down'
import 'vue-awesome/icons/server'

window.MulticalculoEmpresarial = {
    onSave: value => {},
    onSaveClient: value => {},
    onSaveInsurerQuotation: value => {},
    onLoadFields: fields => store.commit('setQuotation', fields),
    printResults: null,
}

Vue.component('icon', Icon)
Vue.component('v-select', vSelect)

Vue.use(VueResource)
Vue.use(VueTheMask)
Vue.use(VueCookies)

Vue.http.interceptors.push((request, next) => {
    if (config.token && !request.url.includes('api.automation') && !request.params["token"]) {
        request.params['token'] = config.token
    }    
    next()
})

new Vue({
    store,
    config,
    eventBus,
    name: 'MulticalculoEmpresarial',
    el: '#' + (config.container || 'app-propostas'),
    render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/enterprise/main.js